import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Intro } from "./components/Intro";
import { Services } from "./components/Services";
import { CurrentProjects } from "./components/CurrentProjects";
import { Portfolio } from "./components/Portfolio";
import { Story } from "./components/Story";
import { Process } from "./components/Process";
import { InquiryForm } from "./components/InquiryForm";
import { FinalCTA } from "./components/FinalCTA";
import { Footer } from "./components/Footer";

const HomePage = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <Intro />
      <Services />
      <CurrentProjects />
      <Portfolio />
      <Story />
      <Process />
      <InquiryForm />
      <FinalCTA />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}

export default App;
